import {CanActivate, Router} from '@angular/router';
import {Injectable} from '@angular/core';
import { AuthClient } from '../auth/auth.client';
import { Subject, Observable } from 'rxjs';
import { RestApi } from 'app/auth/rest.api';

@Injectable()
export class CanActivateAutologinGuard implements CanActivate {

  constructor(
    private _api: RestApi,
    private _authClient: AuthClient,
    private _router: Router) {}

  canActivate() {
    return this._authClient.getAuthenticationTypeAsync().map((authorizationType) => {
      if(authorizationType)
      {
        const isAutoLogin = authorizationType.localeCompare('AutoLogin') === 0;
        if(!isAutoLogin) {
          this._router.navigate(['mc']);
        }
          
        return authorizationType.localeCompare('AutoLogin') === 0;
      }
    });
  }
}
